import { render, staticRenderFns } from "./count.vue?vue&type=template&id=038f2c41&"
import script from "./count.vue?vue&type=script&lang=js&"
export * from "./count.vue?vue&type=script&lang=js&"
import style0 from "./count.vue?vue&type=style&index=0&id=038f2c41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports